import styled from "styled-components";
import { Colors } from "../../config/Constants";
const downArrow = require("../../assets/images/VectorDownArrow.png");
interface Props {
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  value?: string | number;
  data: ({ label: string; value: string } | { label: string; value: number })[];
  name: string;
  required?: boolean;
  helperText?: string | undefined;
  disabled?: boolean;
}

interface StyledSelectProps {
  helperText?: string | undefined;
}

const Selectfield = ({
  onChange,
  label,
  value,
  data,
  name,
  required,
  helperText,
  disabled,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <Select
          disabled={disabled}
          onChange={onChange}
          value={value}
          name={name}
          helperText={helperText}
        >
          {data.map(
            (
              option:
                | { label: string; value: string }
                | { label: string; value: number }
            ) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            )
          )}
        </Select>
        {helperText && <Error>{helperText}</Error>}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Select = styled.select<StyledSelectProps>`
  -webkit-appearance:none;
  background: url(${downArrow}) no-repeat; 
  background-position: calc(100% - 0.5rem);
  font-family: Poppins-Medium;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 1rem;
  padding: 0.85rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  color: ${(props) => (props.value ? Colors.black : Colors.autumnFog)};
  :focus {
    outline: none;
  }
  > option {
    color: ${Colors.black};
  }
  > option:first-child {
    color: ${Colors.purplishGrey};
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor:no-drop;
  }
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #5b5f7b;
  margin-bottom: 0.25rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default Selectfield;
